import queryString from "query-string";
import { withRouter } from "react-router";
import AuthenticationActioner from "../../services/authentication/actioner";
import { connect } from "react-redux";

import UserUtils from "services/user/utils";
import HalfLayout from "components/HalfLayout";
import RocketLayout from "components/RocketLayout";
import { replace, push } from "connected-react-router";
import { SSOLayout } from "./components/SSOLayout";
import { useEffect, useRef } from "react";

const SSO = ({ setAuthFromSSO, replace, location, ...props }) => {
  const searchParameters = queryString.parse(location.search);
  const intialized = useRef(false);

  useEffect(() => {
    if (intialized.current) return;
    intialized.current = true;
    setAuthFromSSO(searchParameters.code).then((user) =>
      replace(UserUtils.getDefaultRoute(user))
    );
  }, [searchParameters.code, replace, setAuthFromSSO]);

  return (
    <HalfLayout
      leftComponent={<RocketLayout location={location} />}
      rightComponent={<SSOLayout location={location} />}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  setAuthFromSSO: (code) =>
    dispatch(AuthenticationActioner.setAuthFromSSO(code)),
  replace: (route) => dispatch(push(route)),
});

export default withRouter(connect(null, mapDispatchToProps)(SSO));
